module.exports = __webpack_public_path__ + "media/images/pic/brodno/not_just_courses_bg-9750318d587e4d781d2db6f9e6936abe.png";